import { useEffect, useState } from "react";

export default function useStateWithLocalStorage<T>(
  key: string,
  initialValue: T,
): [T, React.Dispatch<React.SetStateAction<T>>] {
  function getStorageValue(key: string, defaultValue: T) {
    // getting stored value
    const saved = localStorage.getItem(key);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (error) {
        // If parsing fails (e.g., "undefined" string), remove the invalid value and return default
        console.warn(`Invalid JSON in localStorage for key "${key}":`, saved);
        localStorage.removeItem(key);
        return defaultValue;
      }
    }
    return defaultValue;
  }
  const [value, setValue] = useState(() => {
    return getStorageValue(key, initialValue);
  });

  useEffect(() => {
    // storing input name
    // Convert undefined to null before stringifying to avoid "undefined" string
    const valueToStore = value === undefined ? null : value;
    localStorage.setItem(key, JSON.stringify(valueToStore));
  }, [key, value]);

  return [value, setValue];
}
